/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { customFieldList } from '../../axios/customFieldList'
import type {
	CustomFieldListError,
	CustomFieldListPathParams,
	CustomFieldListResponse,
} from '../../types/CustomFieldList'

export const customFieldListQueryKey = (
	organisation: CustomFieldListPathParams['organisation'],
	location: CustomFieldListPathParams['location'],
) => [{ url: '/:organisation/custom_fields/:location', params: { organisation, location } }] as const

export type CustomFieldListQueryKey = ReturnType<typeof customFieldListQueryKey>

/** @see backend/nexus/modules/CustomField/Http/Controllers/CustomFieldController.php CustomFieldController::list */
export function customFieldListQueryOptions(
	organisation: CustomFieldListPathParams['organisation'],
	location: CustomFieldListPathParams['location'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		CustomFieldListResponse,
		AxiosError<CustomFieldListError>,
		CustomFieldListResponse,
		CustomFieldListQueryKey
	>({
		queryKey: customFieldListQueryKey(organisation, location),
		queryFn: ({ signal }) => customFieldList(organisation, location, { signal, ...config }).then(res => res.data),
		enabled: !!(organisation && location),
	})
}

/** @see backend/nexus/modules/CustomField/Http/Controllers/CustomFieldController.php CustomFieldController::list */
export function useCustomFieldList<TSelectData = CustomFieldListResponse>(
	organisation: CustomFieldListPathParams['organisation'],
	location: CustomFieldListPathParams['location'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CustomFieldListResponse,
					AxiosError<CustomFieldListError>,
					TSelectData,
					CustomFieldListQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CustomFieldListError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...customFieldListQueryOptions(organisation, location),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/CustomField/Http/Controllers/CustomFieldController.php CustomFieldController::list */
export function useCustomFieldListSuspense<TSelectData = CustomFieldListResponse>(
	organisation: CustomFieldListPathParams['organisation'],
	location: CustomFieldListPathParams['location'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CustomFieldListResponse,
					AxiosError<CustomFieldListError>,
					TSelectData,
					CustomFieldListQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CustomFieldListError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...customFieldListQueryOptions(organisation, location),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
